module.exports = __webpack_public_path__ + "static/img/jiaotong-10.4d342e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-10.png
// module id = /UO8
// module chunks = 1